<template>
  <div v-if="isOpen" class="fixed z-10 inset-0 overflow-y-auto">
    <div class="flex items-center justify-center min-h-screen p-4">
      <div class="bg-white w-full max-w-md rounded-lg shadow-xl p-6 relative">
        <button
          @click="closeModal"
          class="absolute top-2 right-2 text-gray-600 hover:text-gray-800 focus:outline-none"
        >
          <svg class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
          </svg>
        </button>
        <h3 class="text-2xl font-semibold text-gray-800 mb-4">
          Candidate Details
        </h3>
        <div v-if="application">
          <p class="text-gray-700 mb-2"><strong>Name:</strong> {{ application.name }}</p>
          <p class="text-gray-700 mb-2"><strong>Email:</strong> {{ application.email }}</p>
          <p class="text-gray-700 mb-2"  v-if="application.phoneNumber"><strong>Phone:</strong> {{ application.countryCode }} {{ application.phoneNumber }}</p>
          <div class="mb-2">
            <strong>Resume:</strong>
              <a v-if="application.linkedin" :href="application.linkedin" target="_blank" rel="noopener noreferrer" class="ml-2 text-blue-500 hover:text-blue-700 underline">LinkedIn profile</a>
             <textarea
                rows="10"
                class="w-full mt-2 p-2 border rounded text-gray-700"
                readonly
                :value="application.cv"  />
          </div>
        </div>
        <div v-else>
          <p class="text-gray-700 mb-2">Candidate information not available.</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    isOpen: Boolean,
    application: Object,
  },
  methods: {
    closeModal() {
      this.$emit("close");
    },
  },
};
</script>